"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.install = void 0;
var index_1 = __importDefault(require("./index"));
function install(Vue, options) {
    if (options === void 0) { options = {}; }
    var Logger;
    if (index_1.default && this instanceof index_1.default) {
        Logger = this;
        if (options !== {})
            Logger.apply(options);
    }
    else {
        Logger = new index_1.default(options);
    }
    Vue.prototype.$log = Logger;
    Vue.prototype.$logger = Logger;
}
exports.install = install;
//# sourceMappingURL=install.js.map